import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

import { Box, Button, Paper, Stack, Typography } from "@mui/material";

import React, { useState } from "react";
import styled from "@emotion/styled";
import EditIcon from "@mui/icons-material/Edit";

import UserContactFrom from "../ProfileModal/AddContactFrom";
import { useSelector } from "react-redux";
import { RegistrationStatus } from "../../common/enum";


const ManageContacts = ({ t, contact }) => {
  const [editContacts, setEditContacts] = useState(false);
  const [open, setOpen] = useState(false);
  const [ContactId, setContactId] = useState();
  
  const {
    auth: {
      user: { status },
    },
  } = useSelector((state) => state);



  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    color: theme.palette.text.secondary,
    display: "flex",
    width: "100%",
    padding: "10px",
    position: "relative",
    alignContent: "center",
    justifyContent: "space-between",
  }));



  return (
    <>
     <Paper
    variant="outlined"
    sx={{
      display: "flex",
      flexDirection: "column",
      p: 1,
    }}
  >
      <Stack direction={"row"} justifyContent="end">
        <Button
          onClick={() => {
            setOpen(true);
            setEditContacts(false);
          }}
          startIcon={<AddCircleOutlineIcon />}
          variant="contained"
          sx={{ borderRadius: "4px" }}
          disabled={
            status === RegistrationStatus.inActive ||
            status === RegistrationStatus.inAtivo ||
            status === RegistrationStatus.revoked
          }
        >
          {t("addContact")}
        </Button>
      </Stack>
      <Box
        mt={4}
        sx={{
          display: "grid",
          gridTemplateColumns: {
            lg: "auto",
          },
          gap: "30px",
          width: "100%",
          maxHeight: "500px",
          overflow: "auto",

          padding: 1,
        }}
      >
        {contact.length > 0 &&
          contact.slice(1).map((d) => (
            <React.Fragment key={d.contactId}>
              {editContacts === false && open === false && (
                <Item
                  sx={{
                    border: contact ? "2px solid #198754" : "1px solid #dddddd",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                  }}
                >
                  <Stack direction={"row"}>
                    <img
                      src="/static/dashboard/map.svg"
                      alt="map"
                      style={{ height: "50px" }}
                    />
                    <Box marginLeft={"10px"}>
                      <Typography fontSize={"subheading"} fontWeight={"bold"}>
                        {d.name} ({d.designation})
                      </Typography>
                      <Typography fontSize={"subheading"}>
                        {d.email}, {d.mobile}
                      </Typography>
                    </Box>
                  </Stack>
                  <Button
                    // onClick={() => setEditContacts(true)}
                    onClick={() => {
                      setEditContacts(true);
                      setContactId(d.id);
                    }}
                    startIcon={<EditIcon />}
                    sx={{ borderRadius: "4px" }}
                    disabled={
                      status === RegistrationStatus.inActive ||
                      status === RegistrationStatus.inAtivo ||
                      status === RegistrationStatus.revoked
                    }
                  >
                    {t("edit")}
                  </Button>
                </Item>
              )}
              {editContacts === true && ContactId == d.id && (
                <UserContactFrom
                  setEditContacts={setEditContacts}
                  editContacts={editContacts}
                  contact={d}
                  t={t}
                 
                />
              )}
            </React.Fragment>
          ))}
        {contact.length === 0 && (
          <Typography fontSize={"h5"} fontWeight={"bold"}>
            {t("noContactToShow")}
          </Typography>
        )}
      </Box>
      {open && <UserContactFrom setOpen={setOpen} t={t} />}
      </Paper>
    </>
    
  );
};

export default ManageContacts;
